import { render, staticRenderFns } from "./Notion.vue?vue&type=template&id=771d580c&scoped=true"
import script from "./Notion.vue?vue&type=script&lang=js"
export * from "./Notion.vue?vue&type=script&lang=js"
import style0 from "./Notion.vue?vue&type=style&index=0&id=771d580c&prod&lang=stylus&scoped=true"
import style1 from "./Notion.vue?vue&type=style&index=1&id=771d580c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771d580c",
  null
  
)

export default component.exports